import { h } from "preact";

import i18n from "../i18n";
import Icon from "./Icon.jsx";
import ListItem from "./ListItem.jsx";

export default function ChecklistItem(props) {
  function handleCheckChanged(event) {
    props.onToggle(props.item.id, event.target.checked);
  }

  return (
    <ListItem
      labelFor={`checklist-${props.item.id}`}
      secondLine={i18n.t(`checklist_tasks.${props.item.id}.description`)}
      iconFront={
        <input
          type="checkbox"
          onInput={handleCheckChanged}
          checked={props.data.done}
          id={`checklist-${props.item.id}`}
        />
      }
      iconBack={
        props.item.attachment && (
          <a
            class="link--plain"
            href={props.item.attachment.src}
            title={i18n.t(`documents.${props.item.attachment.id}.title`)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon>get_app</Icon>
          </a>
        )
      }
    >
      {i18n.t(`checklist_tasks.${props.item.id}.title`)}
    </ListItem>
  );
}
